/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, January 25th 2023, 1:39:51 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import FormLabel from "@mui/material/FormLabel";
import PhoneInput, { PhoneInputProps } from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { OSFormInputProps, useUncontrolledInput } from "ui-widgets/forms";
import { useOSFormContext } from "ui-widgets/forms/providers";
import {
  APIFormInputErrorWrapper,
  CustomInputValidationErrorWrapper,
  HelperTextInputWrapper,
} from "ui-widgets/forms/FormInputWrappers";

export type PhoneNumberFormInputProps<T> = OSFormInputProps<T> & PhoneInputProps & React.HTMLProps<HTMLInputElement>;

export const PhoneNumberFormInput = <T,>(props: PhoneNumberFormInputProps<T>) => {
  const {
    uncontrolledProps: { required },
  } = useUncontrolledInput<T>(props);

  const { watch, setValue } = useOSFormContext<T>();

  const watchedValue = watch(props.schema_field_key as any) as string;

  const onChangePhoneNumber = (value: any) => {
    setValue(props.schema_field_key as any, value);
  };

  return (
    <APIFormInputErrorWrapper schema_field_key={props.schema_field_key} label={props.label}>
      <CustomInputValidationErrorWrapper schema_field_key={props.schema_field_key} label={props.label}>
        <HelperTextInputWrapper helperText={props.helperText}>
          {props.label && (
            <FormLabel component="legend">
              {props.label}
              {required && <> *</>}
            </FormLabel>
          )}
          <PhoneInput country={"ke"} value={watchedValue} onChange={onChangePhoneNumber} />
        </HelperTextInputWrapper>
      </CustomInputValidationErrorWrapper>
    </APIFormInputErrorWrapper>
  );
};
